import { render, staticRenderFns } from "./PrintPositionsManagerHeader.vue?vue&type=template&id=88e224f4&scoped=true"
import script from "./PrintPositionsManagerHeader.vue?vue&type=script&lang=ts"
export * from "./PrintPositionsManagerHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintPositionsManagerHeader.vue?vue&type=style&index=0&id=88e224f4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "88e224f4",
  null
  ,true
)

export default component.exports